<template>
  <div>
    <div v-if="showBreadcrumb" class="row">
      <div class="col">
        <breadcrumb :transparent="true">
          <breadcrumb-item v-if="showSurveyBreadcrumb">
            <router-link to="/admin/surveys">Surveys</router-link>
          </breadcrumb-item>
          <breadcrumb-item>
            <router-link v-if="!_isNullOrEmpty(instanceInfo.hspSurveyId)" :to="{ name: 'Instances', params: { surveyId: instanceInfo.hspSurveyId, surveyInfo: surveyInfo, routeFrom: 'instance' }}">{{ instanceInfo.surveyName }} Instances</router-link>
          </breadcrumb-item>
          <breadcrumb-item active>
            {{ instanceInfo.surveyUrlId }}
          </breadcrumb-item>
        </breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>{{ instanceInfo.surveyName }} ({{ instanceInfo.surveyUrlId }})</h2>
      </div>
    </div>
    <zoom-center-transition :duration="200" mode="out-in">
      <router-view></router-view>
    </zoom-center-transition>
  </div>
</template>
<script>
  import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb.vue';
  import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem.vue';
  import { ZoomCenterTransition } from 'vue2-transitions';
  import { mapGetters, mapActions } from 'vuex';
  import { isNullOrEmpty } from 'src/modules/utils';

  export default {
    components: {
      Breadcrumb,
      BreadcrumbItem,
      ZoomCenterTransition
    },
    data() {
      return {
        surveyInfo: null,
      };
    },
    computed: {
      showBreadcrumb() {
        if (isNullOrEmpty(this.$route.params.routeFrom) || this.$route.params.routeFrom === "instances") {
          return true;
        }

        // If routed from the Login or Surveys page, don't display the breadcrumb
        return false;
      },
      showSurveyBreadcrumb() {
        if (isNullOrEmpty(this.userAssignments) || (this.userAssignments.numberOfSurveys > 1 && this.userAssignments.numberOfSurveyInstances > 1)) {
          return true;
        }

        return false;
      },
      ...mapGetters(['instanceInfo','userAssignments'])
    },
    methods: {
      _isNullOrEmpty(obj) {
        return isNullOrEmpty(obj);
      }
    },
    created() {
      var params = this.$route.params;

      this.surveyInfo = params.surveyInfo;
      this.surveyUrlId = params.urlId;

      let payload = {
        surveyUrlId: this.surveyUrlId
      }

      this.$store.dispatch('addInstanceInfo', payload);
    }
  }
</script>
